import { render, staticRenderFns } from "./PickFileForUpload.vue?vue&type=template&id=670b9e20&"
import script from "./PickFileForUpload.vue?vue&type=script&lang=js&"
export * from "./PickFileForUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports